
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const ash: Operator = {
	id: 'ash',
	name: 'Ash',
	role: 'Attacker',
	org: 'FBI SWAT',
	squad: 'REDHAMMER',
	ratings: {
		health: 1,
		speed: 3,
		difficulty: 2
	},
	meta: {
		gender: 'f',
		country: 'us',
		season: 'Release',
		height: 170,
		weight: 63,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Eliza Cohen',
		birthplace: 'Jerusalem, Israel'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="m294.42 139.783-15.652 43.768-8.116-51.304-48.406 82.029 37.971-120.87-125.507 42.898 82.609-51.014h-67.246l62.029-23.188-49.935-17.101L45 45v260h260v-72.333l-3.333-46.507z" style="opacity:.4"></path><path d="M277 277H73V73h119.101l-15.652 8.522 43.188 1.449-44.348 35.072 84.928-24.638-24.348 86.667 33.913-42.609 7.217 29.565z" style="fill:#d75b2a"></path><path d="M239.833 45.583 191.417 32.75 201.25 45h-39.083l42.125 18.208-64.903 23.847h72.528L97.111 152.389 252.5 101.722l-42.792 141.403 58.458-96.833L277 208l14-47.778 14 72.444V104l12.333 4.333L305 76.111l-.222 19.444-7.222-1.778-17.111 65-6.799-41.59-30.424 50.59 24.889-81.889-78.667 25.667L250 77.222h-53.889l33.778-12.444-10.778-13.444z" style="fill:#fff"></path><path d="M73 277V161.889l24.111-9.5L252.5 101.722 199.444 277z"></path><path d="m250.167 194.333-2.584 14.917 10.167-4.917zm13.166 39.417 8 18.75h-19.75zM134.167 98.25l2.916 19.417 15.834-14.5zm40.669 86.01-41.461 40.461-7.464-7.649 41.461-40.46-6.853-7.023-48.56 47.387 21.651 22.187 48.559-47.388zm-81.128 8.615 32.417 4.167-16.958 16.5-22.084-14.292zm17.125 28.042 18.417 19.166-11.917 2.229-9.489-9.489zm25.834 20.805 16.611-16.611 1.222 35.222-6.556 6.334zm64.746-110.289 11.651 39.645 3.203-7.717-9.93-33.789zm16.396-6.197 5.921 20.147 3.095-7.455-4.258-14.489zm-8.137 3.075 8.764 29.822 3.123-7.524-7.086-24.113q-2.4.909-4.801 1.815m-27.839 10.522L164 156.083l-2.167 10.021 23.219 24.086 10.531-1.856 14.695-14.124-12.201-41.516zm52.917-20-8.849 3.344 3.092 10.523q2.88-6.933 5.757-13.867" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-ash'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
